/**
 * Created by squitty on 6/28/17.
 */
import AbstractBrickConfig from './abstract-brick-config';

export default class AbstractWatchableBrickConfig extends AbstractBrickConfig {
  constructor(params) {
    super(params);

    const watchableType = params.watchableType || params.watchable_type || params.resource_type;
    const watchableId = params.watchableId || params.watchable_id || params.resource_id;
    this.search = params.search;
    this.searchYear = params.searchYear || params.search_year;

    this.setWatchable(watchableType, watchableId);
  }

  setWatchable(watchableType, watchableId) {
    if (watchableType) {
      this.watchableType = watchableType.toLowerCase().trim();
    }

    if (watchableId) {
      this.watchableId = parseInt(watchableId, 10);
    }
  }

  resetSearch() {
    this.search = null;
  }

  isRequiresSearch() {
    const isWatchableSet = this.watchableType && this.watchableId;

    return this.search && !isWatchableSet;
  }

  isMovie() {
    return this.watchableType && this.watchableType.toLowerCase() === 'movie';
  }

  isShow() {
    return this.watchableType && this.watchableType.toLowerCase() === 'show';
  }

  isSeason() {
    return this.watchableType && this.watchableType.toLowerCase() === 'season';
  }

  isEpisode() {
    return this.watchableType && this.watchableType.toLowerCase() === 'episode';
  }

  merge(otherBrickData) {
    super.merge(otherBrickData);

    this.watchableType = this.watchableType || otherBrickData.watchableType;
    this.watchableId = this.watchableId || otherBrickData.watchableId;
  }

  errors() {
    const errorArray = super.errors();

    if (!this.watchableType && !this.search) {
      errorArray.push('watchableType cannot be null');
    }

    if (!this.watchableId && !this.search) {
      errorArray.push('watchableId cannot be null');
    }

    if (this.watchableId
      && this.watchableType
      && !this.isMovie()
      && !this.isShow()
      && !this.isSeason()
      && !this.isEpisode()) {
      errorArray.push(`unrecognized watchableType -- '${this.watchableType}'`);
    }

    return errorArray;
  }

  toQueryParamObject() {
    const queryParams = super.toQueryParamObject();

    if (this.watchableType) queryParams.watchableType = this.watchableType;
    if (this.watchableId) queryParams.watchableId = this.watchableId;

    return queryParams;
  }
}




// WEBPACK FOOTER //
// ./src/models/abstract-watchable-brick-config.js